export class DocFormulaFactory {
    /**
     * @import {Formula} from 'Services/Documents/formula';
     * @param {string} version
     * @returns {Promise<DocFormula>}
     */
    async createFormula(version) {
        switch (version) {
            case 'doc.formula.v1.fx':
                const { DocFormulaV1FacturX } = await import(
                    'Services/Documents/docFormulaV1FacturX'
                );
                return new DocFormulaV1FacturX();
            default:
                const { DocFormulaV1 } = await import('Services/Documents/docFormulaV1');
                return new DocFormulaV1();
        }
    }
}
